import { Path, Svg } from '../../svg';

/**
 * Apple logo, drawn once with the shared SVG primitives so it renders
 * identically on web + native. Replaces flashka-app's old `U+F8FF` glyph,
 * which only Apple platforms' system fonts carry — on Android it rendered as
 * a broken box.
 *
 * Single-tone: `fill` follows `color`, which Button / Badge inject per
 * (variant × dark mode). `strokeWidth` is accepted for the `IconComponent`
 * shape and ignored.
 */
export function AppleIcon({
  color = 'currentColor',
  size = 20,
  className,
}: {
  color?: string;
  size?: number;
  strokeWidth?: number;
  className?: string;
}) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <Path
        fill={color}
        d="M16.36 12.79c.03 3.2 2.81 4.27 2.84 4.28-.02.08-.44 1.52-1.46 3-.88 1.27-1.8 2.54-3.24 2.57-1.42.03-1.87-.84-3.49-.84-1.62 0-2.13.81-3.47.87-1.39.05-2.45-1.38-3.34-2.65C2.38 17.42.98 12.7 2.85 9.47a5.4 5.4 0 0 1 4.56-2.77c1.37-.03 2.66.92 3.49.92.84 0 2.4-1.14 4.05-.97.69.03 2.62.28 3.86 2.1-.1.06-2.31 1.35-2.45 4.04ZM13.87 4.9c.74-.9 1.24-2.14 1.1-3.38-1.07.04-2.36.71-3.12 1.6-.69.8-1.29 2.07-1.13 3.29 1.19.09 2.4-.6 3.15-1.51Z"
      />
    </Svg>
  );
}
